import { render, staticRenderFns } from "./ShiftTrucksAndLoads.vue?vue&type=template&id=23193257"
import script from "./ShiftTrucksAndLoads.vue?vue&type=script&lang=js"
export * from "./ShiftTrucksAndLoads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports